// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsors-page .sponsor-row {
  height: 60px;
}
.sponsors-page .sponsor-row img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-height: 50px;
  max-width: 90%;
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}
.sponsors-page .sponsor-row a:hover {
  text-decoration: none;
  color: #4330ff;
  opacity: 0.7;
}

.sponsor-page {
  padding: 1em 0 1em 0;
}
.sponsor-page hr {
  margin-top: 0;
  margin-bottom: 0;
}
.sponsor-page .logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  max-width: 225px;
  height: auto;
}
.sponsor-page .no-logo {
  text-align: center;
  margin-bottom: 20px;
  font-size: x-large;
}
.sponsor-page button {
  width: 100%;
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 0.5em;
}
.sponsor-page .active-button {
  background-color: #4330ff;
  color: white;
}
.sponsor-page .blue-header {
  color: #4330ff;
}
.sponsor-page .user-list {
  padding: 5px 0 5px 0;
  position: relative;
}
.sponsor-page .user-list .user-icons {
  margin: 0.5em;
  color: #606060;
  position: absolute;
  top: 0;
  right: 0;
}
.sponsor-page .user-list .user-icons ul li {
  list-style-type: none;
}
.sponsor-page .external-link a {
  color: #4330ff;
  cursor: default;
}
.sponsor-page .external-link a:hover {
  text-decoration: none;
}
.sponsor-page .media-section a {
  color: #000;
  display: block;
  width: 100%;
  float: left;
}
.sponsor-page .media-section a:hover {
  text-decoration: none;
}
.sponsor-page .media-section a ul {
  float: left;
}
.sponsor-page .media-section a ul li {
  border-bottom: none;
  margin: -10px 15px;
  color: #c0c0c0;
}
.sponsor-page .media-section a ul li.attachment-title {
  font-size: 1.1em;
  font-weight: bold;
  color: #000;
}
.sponsor-page .media-section a ul li:hover {
  background: transparent;
}
.sponsor-page .media-section .fa {
  font-size: 2.5em;
}
.sponsor-page .media-section .chevron {
  color: #c0c0c0;
  font-size: 0.75em;
}
.sponsor-page .media-section ul {
  padding-left: 0px;
}
.sponsor-page .media-section ul li {
  list-style: none;
  border-bottom: 2px solid #eaeaea;
  padding: 0.5em 0;
  display: block;
  width: 100%;
  float: left;
}
.sponsor-page .media-section ul li:hover {
  background-color: #f2f2f2;
}
.sponsor-page .has-note {
  background-color: #4330ff;
  color: white;
}

.no-logo {
  text-align: center;
  color: #404040;
  font-size: 30px;
}

.media-section a {
  color: #000;
  display: block;
  width: 100%;
  float: left;
}
.media-section a:hover {
  text-decoration: none;
}
.media-section a ul {
  float: left;
}
.media-section a ul li {
  border-bottom: none;
  margin: -10px 15px;
  color: #c0c0c0;
}
.media-section a ul li.attachment-title {
  font-size: 1.1em;
  font-weight: bold;
  color: #000;
}
.media-section a ul li:hover {
  background: transparent;
}
.media-section .fa {
  font-size: 2.5em;
}
.media-section .chevron {
  color: #c0c0c0;
  font-size: 0.75em;
}
.media-section ul {
  padding-left: 0px;
}
.media-section ul li {
  list-style: none;
  border-bottom: 2px solid #eaeaea;
  padding: 0.5em 0;
  display: block;
  width: 100%;
  float: left;
}
.media-section ul li:hover {
  background-color: #f2f2f2;
}

.note-page .sponsor-logo {
  text-align: center;
}
.note-page .sponsor-logo img {
  height: auto;
  max-width: 225px;
}
.note-page .sponsor-logo:hover {
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/components/Sponsors/sponsors.scss","webpack://./src/components/Sponsors/sponsors.css","webpack://./src/app/variables.scss"],"names":[],"mappings":"AAGE;EACE,YAAA;ACFJ;ADGI;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;ACDN;ADIM;EACE,qBAAA;EACA,cEQM;EFPN,YAAA;ACFR;;ADQA;EACE,oBAAA;ACLF;ADME;EACE,aAAA;EACA,gBAAA;ACJJ;ADME;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;ACJJ;ADME;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;ACJJ;ADME;EACE,WAAA;EACA,kBAAA;EACA,yBEtCY;EFuCZ,yBAAA;EACA,cEvBU;EFwBV,oBAAA;ACJJ;ADME;EACE,yBE3BU;EF4BV,YAAA;ACJJ;ADME;EACE,cE/BU;AD2Bd;ADME;EACE,oBAAA;EACA,kBAAA;ACJJ;ADKI;EACE,aAAA;EACA,cElDa;EFmDb,kBAAA;EACA,MAAA;EACA,QAAA;ACHN;ADIM;EACE,qBAAA;ACFR;ADQI;EACE,cElDQ;EFmDR,eAAA;ACNN;ADOM;EACE,qBAAA;ACLR;ADWI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;ACTN;ADUM;EACE,qBAAA;ACRR;ADUM;EACE,WAAA;ACRR;ADSQ;EACE,mBAAA;EACA,kBAAA;EACA,cErFI;AD8Ed;ADQU;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;ACNZ;ADQU;EACE,uBAAA;ACNZ;ADWI;EACE,gBAAA;ACTN;ADWI;EACE,cErGQ;EFsGR,iBAAA;ACTN;ADWI;EACE,iBAAA;ACTN;ADUM;EACE,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;ACRR;ADSQ;EACE,yBEtHM;AD+GhB;ADYE;EACE,yBE3GU;EF4GV,YAAA;ACVJ;;ADcA;EACE,kBAAA;EACA,cE7HU;EF8HV,eAAA;ACXF;;ADeE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;ACZJ;ADaI;EACE,qBAAA;ACXN;ADaI;EACE,WAAA;ACXN;ADYM;EACE,mBAAA;EACA,kBAAA;EACA,cEjJM;ADuId;ADWQ;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;ACTV;ADWQ;EACE,uBAAA;ACTV;ADcE;EACE,gBAAA;ACZJ;ADcE;EACE,cEjKU;EFkKV,iBAAA;ACZJ;ADcE;EACE,iBAAA;ACZJ;ADaI;EACE,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;ACXN;ADYM;EACE,yBElLQ;ADwKhB;;ADiBE;EACE,kBAAA;ACdJ;ADeI;EACE,YAAA;EACA,gBAAA;ACbN;ADeI;EACE,eAAA;ACbN","sourcesContent":["@import '../../app/variables.scss';\n\n.sponsors-page {\n  .sponsor-row {\n    height: 60px;\n    img {\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n      max-height: 50px;\n      max-width: 90%;\n      position: relative;\n      top: 40%;\n      transform: translateY(-50%);\n    }\n    a{\n      &:hover{\n        text-decoration: none;\n        color: $evanta-blue;\n        opacity: 0.7;\n      }\n    }\n  }\n}\n\n.sponsor-page {\n  padding: 1em 0 1em 0;\n  hr {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .logo {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 20px;\n    max-width: 225px;\n    height: auto;\n  }\n  .no-logo {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: x-large;\n  }\n  button {\n    width: 100%;\n    border-radius: 5px;\n    background-color: $lightest-gray;\n    border: 1px solid $medium-gray;\n    color: $evanta-blue;\n    margin-bottom: 0.5em;\n  }\n  .active-button {\n    background-color: $evanta-blue;\n    color: white;\n  }\n  .blue-header {\n    color: $evanta-blue;\n  }\n  .user-list {\n    padding: 5px 0 5px 0;\n    position: relative;\n    .user-icons {\n      margin: .5em;\n      color: $medium-dark-gray;\n      position: absolute;\n      top: 0;\n      right: 0;\n      ul li {\n        list-style-type: none;\n      }\n    }\n  }\n\n  .external-link {\n    a {\n      color: $evanta-blue;\n      cursor: default;\n      &:hover {\n        text-decoration: none;\n      }\n    }\n  }\n\n  .media-section {\n    a {\n      color: #000;\n      display: block;\n      width: 100%;\n      float: left;\n      &:hover {\n        text-decoration: none;\n      }\n      ul {\n        float: left;\n        li {\n          border-bottom: none;\n          margin: -10px 15px;\n          color: $medium-gray;\n          &.attachment-title{\n            font-size: 1.1em;\n            font-weight: bold;\n            color: #000;\n          }\n          &:hover {\n            background: transparent;\n          }\n        }\n      }\n    }\n    .fa{\n      font-size: 2.5em;\n    }\n    .chevron {\n      color: $medium-gray;\n      font-size: .75em;\n    }\n    ul {\n      padding-left: 0px;\n      li {\n        list-style: none;\n        border-bottom: 2px solid $light-gray;\n        padding: .5em 0;\n        display: block;\n        width: 100%;\n        float: left;\n        &:hover{\n          background-color: $lightest-gray;\n        }\n      }\n    }\n  }\n  .has-note {\n    background-color: $evanta-blue;\n    color: white;\n  }\n}\n\n.no-logo {\n  text-align: center;\n  color: $dark-gray;\n  font-size: 30px;\n}\n\n.media-section {\n  a {\n    color: #000;\n    display: block;\n    width: 100%;\n    float: left;\n    &:hover {\n      text-decoration: none;\n    }\n    ul {\n      float: left;\n      li {\n        border-bottom: none;\n        margin: -10px 15px;\n        color: $medium-gray;\n        &.attachment-title{\n          font-size: 1.1em;\n          font-weight: bold;\n          color: #000;\n        }\n        &:hover {\n          background: transparent;\n        }\n      }\n    }\n  }\n  .fa{\n    font-size: 2.5em;\n  }\n  .chevron {\n    color: $medium-gray;\n    font-size: .75em;\n  }\n  ul {\n    padding-left: 0px;\n    li {\n      list-style: none;\n      border-bottom: 2px solid $light-gray;\n      padding: .5em 0;\n      display: block;\n      width: 100%;\n      float: left;\n      &:hover{\n        background-color: $lightest-gray;\n      }\n    }\n  }\n}\n\n.note-page {\n  .sponsor-logo {\n    text-align: center;\n    img {\n      height: auto;\n      max-width: 225px;\n    }\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n",".sponsors-page .sponsor-row {\n  height: 60px;\n}\n.sponsors-page .sponsor-row img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  max-height: 50px;\n  max-width: 90%;\n  position: relative;\n  top: 40%;\n  transform: translateY(-50%);\n}\n.sponsors-page .sponsor-row a:hover {\n  text-decoration: none;\n  color: #4330ff;\n  opacity: 0.7;\n}\n\n.sponsor-page {\n  padding: 1em 0 1em 0;\n}\n.sponsor-page hr {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.sponsor-page .logo {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 20px;\n  max-width: 225px;\n  height: auto;\n}\n.sponsor-page .no-logo {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: x-large;\n}\n.sponsor-page button {\n  width: 100%;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 0.5em;\n}\n.sponsor-page .active-button {\n  background-color: #4330ff;\n  color: white;\n}\n.sponsor-page .blue-header {\n  color: #4330ff;\n}\n.sponsor-page .user-list {\n  padding: 5px 0 5px 0;\n  position: relative;\n}\n.sponsor-page .user-list .user-icons {\n  margin: 0.5em;\n  color: #606060;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.sponsor-page .user-list .user-icons ul li {\n  list-style-type: none;\n}\n.sponsor-page .external-link a {\n  color: #4330ff;\n  cursor: default;\n}\n.sponsor-page .external-link a:hover {\n  text-decoration: none;\n}\n.sponsor-page .media-section a {\n  color: #000;\n  display: block;\n  width: 100%;\n  float: left;\n}\n.sponsor-page .media-section a:hover {\n  text-decoration: none;\n}\n.sponsor-page .media-section a ul {\n  float: left;\n}\n.sponsor-page .media-section a ul li {\n  border-bottom: none;\n  margin: -10px 15px;\n  color: #c0c0c0;\n}\n.sponsor-page .media-section a ul li.attachment-title {\n  font-size: 1.1em;\n  font-weight: bold;\n  color: #000;\n}\n.sponsor-page .media-section a ul li:hover {\n  background: transparent;\n}\n.sponsor-page .media-section .fa {\n  font-size: 2.5em;\n}\n.sponsor-page .media-section .chevron {\n  color: #c0c0c0;\n  font-size: 0.75em;\n}\n.sponsor-page .media-section ul {\n  padding-left: 0px;\n}\n.sponsor-page .media-section ul li {\n  list-style: none;\n  border-bottom: 2px solid #eaeaea;\n  padding: 0.5em 0;\n  display: block;\n  width: 100%;\n  float: left;\n}\n.sponsor-page .media-section ul li:hover {\n  background-color: #f2f2f2;\n}\n.sponsor-page .has-note {\n  background-color: #4330ff;\n  color: white;\n}\n\n.no-logo {\n  text-align: center;\n  color: #404040;\n  font-size: 30px;\n}\n\n.media-section a {\n  color: #000;\n  display: block;\n  width: 100%;\n  float: left;\n}\n.media-section a:hover {\n  text-decoration: none;\n}\n.media-section a ul {\n  float: left;\n}\n.media-section a ul li {\n  border-bottom: none;\n  margin: -10px 15px;\n  color: #c0c0c0;\n}\n.media-section a ul li.attachment-title {\n  font-size: 1.1em;\n  font-weight: bold;\n  color: #000;\n}\n.media-section a ul li:hover {\n  background: transparent;\n}\n.media-section .fa {\n  font-size: 2.5em;\n}\n.media-section .chevron {\n  color: #c0c0c0;\n  font-size: 0.75em;\n}\n.media-section ul {\n  padding-left: 0px;\n}\n.media-section ul li {\n  list-style: none;\n  border-bottom: 2px solid #eaeaea;\n  padding: 0.5em 0;\n  display: block;\n  width: 100%;\n  float: left;\n}\n.media-section ul li:hover {\n  background-color: #f2f2f2;\n}\n\n.note-page .sponsor-logo {\n  text-align: center;\n}\n.note-page .sponsor-logo img {\n  height: auto;\n  max-width: 225px;\n}\n.note-page .sponsor-logo:hover {\n  cursor: pointer;\n}\n\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
